export const state = () => ({
  isAppLoading: true,
});

export const getters = {
  isAppLoading: state => state.isAppLoading,
};

export const mutations = {
  setAppLoading(state, value) {
    state.isAppLoading = value;
  },
};

export const actions = {
  showAppLoading({ commit, state }) {
    if (!state.isAppLoading) commit('setAppLoading', true);
  },
  hideAppLoading({ commit, state }) {
    if (state.isAppLoading) commit('setAppLoading', false);
  },
};
